const getMonthNameFromIndex = ({
  index,
  variant,
}: {
  index: number;
  variant: 'long' | 'short';
}) => {
  const getMonthName = (date: Date) => Intl.DateTimeFormat('en', { month: variant }).format(date);
  const currentYear = new Date().getFullYear();

  return getMonthName(new Date(currentYear, index));
};

export default getMonthNameFromIndex;
